// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback_box-module__card--1zjYV{border:1px solid #c6ced5;background-color:#fff;border-radius:4px;padding:16px}.feedback_box-module__title--22JHr{font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;margin-bottom:8px}.feedback_box-module__label--3NsuF{font-weight:400;font-size:14px;line-height:21px;letter-spacing:0;margin-top:16px;margin-bottom:8px}.feedback_box-module__button_selected--3QWMw{border:1px solid #36b}.feedback_box-module__button--1pbng{margin:0}.feedback_box-module__button--1pbng+.feedback_box-module__button--1pbng{margin-left:8px}.feedback_box-module__textarea--1CX_n{font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}\n", ""]);
// Exports
exports.locals = {
	"card": "feedback_box-module__card--1zjYV",
	"title": "feedback_box-module__title--22JHr",
	"label": "feedback_box-module__label--3NsuF",
	"button_selected": "feedback_box-module__button_selected--3QWMw",
	"button": "feedback_box-module__button--1pbng",
	"textarea": "feedback_box-module__textarea--1CX_n"
};
module.exports = exports;
